module.exports = __webpack_public_path__ + "static/media/station_nyarutarama7.e028c13a.jpeg";